module.exports = __webpack_public_path__ + "ATS/img/ic-排名第3.6535b756.svg";